import { fromJS } from 'immutable';
import {
	SET_ACCESS_TOKEN,
	SET_ACCESS_TOKEN_EXPIRY_TIME,
	SET_AUTH_CATEGORIES,
	USER_LOGOUT,
	SET_ACCOUNT_REALMS,
	SET_ACTIVE_REALM,
	SET_CUSTOMERS_ACTIVE_REALM,
} from '../constants/constants';

const initialState = fromJS({
	accessToken: null,
	tokenExpiryTime: null,
	securityAuthorizedCategories: null,
	accountRealms: [],
	activeRealm: null,
	customersActiveRealm: null,
});

const authReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case SET_ACCESS_TOKEN:
			return state.set('accessToken', action.payload);
		case SET_ACCESS_TOKEN_EXPIRY_TIME:
			return state.set('tokenExpiryTime', action.payload);
		case SET_AUTH_CATEGORIES:
			return state.set('securityAuthorizedCategories', action.payload);
		case SET_ACCOUNT_REALMS:
			return state.set('accountRealms', action.payload);
		case SET_ACTIVE_REALM:
			return state.set('activeRealm', action.payload);
		case SET_CUSTOMERS_ACTIVE_REALM:
			return state.set('customersActiveRealm', action.payload);
		case USER_LOGOUT:
			return initialState;
		default:
			return state;
	}
};

export default authReducer;
